module.exports = __webpack_public_path__ + "static/media/just-cut.c31536d9.svg";